import { isNil } from '#packages/data-collection/libs/lodash';

export const parseIntOrUndefined = (value?: string) =>
  isNil(value) ? undefined : parseInt(value);

export const parseFloatOrUndefined = (value?: string) =>
  isNil(value) ? undefined : parseFloat(value);
